import { createApiRef } from '@backstage/core-plugin-api';
import {
  ReportJsonResponse,
  ReportTypeResponse,
  ReportSubTypeResponse,
} from './types';

/** @public */
export const TestReportApiRef = createApiRef<TestReportApi>({
  id: 'plugin.test-report.service',
});

/** @public */
export interface TestReportApi {
  getTestReport(url: string): Promise<ReportJsonResponse>;
  getReportType(url: string): Promise<ReportTypeResponse>;
  getReportSubType(url: string): Promise<ReportSubTypeResponse>;
}
